import styled from 'styled-components';
import {
  fontFamilySecondary,
  colorBlack900,
  mediaQueryMobileLargeMin,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyNbuTable/styles';
import {
  InputWrapper as Inputs,
  SearchInput as InputSearch,
} from 'components/BanksTable/styles';
import {
  TitleWrapper as SectionTitleWrapper,
  Title as SectionTitle,
  Update as SectionUpdate,
} from 'components/SectionTitle/styles';

export const Wrapper = styled(SectionWrapper)`
  margin-top: 16px;
`;

export const Title = styled.h2`
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 16px;
  color: ${colorBlack900};
`;

export const InputWrapper = styled(Inputs)`
  outline: none;
  margin-bottom: 16px;
  margin-top: 0;
  background: #fff;
  border: 1px solid #cacccb;
  border-radius: 2px;

  &:hover {
    border: 1px solid #87928c;
  }

  ${({ focus }) =>
    focus &&
    ` 
    box-shadow: 0px 0px 0px 2px #35A47C;
   
    
    &:hover {
      box-shadow: 0px 0px 0px 2px #35A47C;
    }
    `}
`;

export const SearchInput = styled(InputSearch)`
  font-size: 16px;
`;

export const TitleWrapper = styled(SectionTitleWrapper)`
  margin-top: 24px;
  flex-direction: column-reverse;
  align-items: flex-start;

  & > p {
    margin-bottom: 8px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;

    & > p {
      margin-bottom: 0;
    }
  }
`;

export const Desc = styled(SectionTitle)`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-bottom: 0;
  }
`;

export const Update = styled(SectionUpdate)``;
